import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC } from 'react';
import { OperatorResponse } from 'src/apis/capacity-management/types';
import { Colors } from 'src/styles';

type PaymentEscalationProps = {
  operator: OperatorResponse;
};

export const PaymentEscalation: FC<PaymentEscalationProps> = ({ operator }) => {
  const { allowsNomination } = operator;
  return (
    <span>
      <FontAwesomeIcon
        icon={allowsNomination ? faCheckCircle : faTimesCircle}
        aria-hidden
        color={allowsNomination ? Colors.success : Colors.error}
      />{' '}
      {allowsNomination ? 'Nomination Allowed' : 'Nomination Denied'}
    </span>
  );
};
